import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    height: '93%',
    justifyContent: 'center',
    '& p': {
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 400,
      marginTop: 16
    }
  }
}))

export default useStyles
